<template>
  <div>
    <MenuLayout></MenuLayout>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <!-- StartOf検索 -->
      <div class="container-fluid">
        <div class="row setting_filter_bg pt-2">
          <div class="col-md-4 my-2" v-if="settingFilterObject['Blood Group']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Blood Group"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.blood_type">
                  <option selected value="">Select</option>
                  <option v-for="value in drop_down.blood_type" :key="value" :value="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Job Category']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Job Category"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.job_category_uid">
                  <option selected value="">Select</option>
                  <option v-for="categoryItem in jobCategoryList" :key="categoryItem.uid" :value="categoryItem.uid">
                    {{ categoryItem.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Interview Status']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Interview Status"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.interview_status">
                  <option selected value="">Select</option>
                  <option v-for="(value, key) in drop_down.interview_status" :key="key" :value="key">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Religion']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Religion"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.religion">
                  <option selected value="">Select</option>
                  <option v-for="(value, key) in drop_down.religion" :key="key" :value="key">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Passport Type']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Passport Type"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.passport_type">
                  <option selected value="">Select</option>
                  <option v-for="value in drop_down.passport_type" :key="value" :value="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['School Grade']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["School Grade"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.edu_history">
                  <option selected value="">Select</option>
                  <option v-for="(value, key) in drop_down.edu_grade" :key="key" :value="key">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Birth(State/City)']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Birth(State/City)"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-on:change="stateChange"
                  v-model="searchData.birth_state">
                  <option selected value="">Select State</option>
                  <option v-for="s in drop_down.birth_state" :key="s.id" :value="s.en">
                    {{ s.en }}
                  </option>
                </select>
                <select class="form-select form-select-sm selectBorder" :disabled="!searchData.birth_state"
                  v-model="searchData.birth_city">
                  <option selected value="">Select City</option>
                  <option v-for="s in drop_down.birth_city" :key="s.id" :value="s.en">
                    {{ s.en }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Foreign travel history']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Foreign travel history"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.foreign_travel_history">
                  <option selected value="">Select</option>
                  <option v-for="t in drop_down.travel_country" :key="t.en" :value="t.en">
                    {{ t.en }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Other Possible Languages']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Other Possible Languages"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.other_possible_languages">
                  <option selected value="">Select</option>
                  <option v-for="l in drop_down.other_possible_languages" :key="l.en" :value="l.en">
                    {{ l.en }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Has Referal']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{ settingFilterObject['Has Referal'] }}</label>
                <div v-for="(value, key) in radio.yes_no" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.has_refer" :value="key">
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Recruited From']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{ settingFilterObject['Recruited From'] }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.recruited_from">
                  <option selected value="">Select</option>
                  <option v-for="value in drop_down.recruited_from" :key="value" :value="value">{{ value }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Name']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Name"]
                }}</label>
                <input type="text" class="form-control form-control-sm" v-model="searchData.name_eng" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Cell Phone']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Cell Phone"]
                }}</label>
                <input type="text" class="form-control form-control-sm" v-model="searchData.cellphone" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Present Address']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Present Address"]
                }}</label>
                <input type="text" class="form-control form-control-sm" v-model="searchData.present_addr" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Residence Address']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Residence Address"]
                }}</label>
                <input type="text" class="form-control form-control-sm" v-model="searchData.residence_address" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Annual Saving Goal']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Annual Saving Goal"]
                }}</label>
                <input type="number" class="form-control form-control-sm" v-model="searchData.annual_saving_goal"
                  @keypress="handleEyeInput($event)" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Desired Employment Period']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Desired Employment Period"]
                }}</label>
                <input type="number" class="form-control form-control-sm" v-model="searchData.desired_employment_period"
                  @keypress="handleEyeInput($event)" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Both Eyes Eyesight']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Both Eyes Eyesight"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.eyesight_botheye">
                  <option selected value="">Select</option>
                  <option v-for="value in [1, 0.8, 0.5, 0.3]" :key="value" :value="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Both Eyes Glasses']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Both Eyes Glasses"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.glass_botheye">
                  <option selected value="">Select</option>
                  <option v-for="value in [1, 0.8, 0.5, 0.3]" :key="value" :value="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Supervising Organization']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Supervising Organization"]
                }}</label>
                <input type="text" class="form-control form-control-sm" v-model="searchData.supervision_organization" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Implementing Organization']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Implementing Organization"]
                }}</label>
                <input type="text" class="form-control form-control-sm"
                  v-model="searchData.implementing_organization" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Date of Birth']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Date of Birth"]
                }}</label>
                <input v-maska:[date_mask.date_option] v-model="this.searchData.dob"
                  class="form-control form-control-sm selectBorder" :placeholder="date_mask.placeholder"
                  :class="{ 'is-invalid': error.dob }" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Apply Date']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Apply Date"]
                }}</label>
                <input v-maska:[date_mask.date_option] v-model="searchData.fromapply_date"
                  :class="{ 'is-invalid': error.apply_date }" class="form-control form-control-sm selectBorder"
                  :placeholder="date_mask.placeholder" />
                <span class="field-seperator">～</span>
                <input v-maska:[date_mask.date_option] v-model="searchData.toapply_date"
                  :class="{ 'is-invalid': error.apply_date }" class="form-control form-control-sm selectBorder"
                  :placeholder="date_mask.placeholder" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Entry Date']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Entry Date"]
                }}</label>
                <input v-maska:[date_mask.date_option] v-model="searchData.fromentry_date"
                  :class="{ 'is-invalid': error.entry_date }" class="form-control form-control-sm selectBorder"
                  :placeholder="date_mask.placeholder" />
                <span class="field-seperator">～</span>
                <input v-maska:[date_mask.date_option] v-model="searchData.toentry_date"
                  :class="{ 'is-invalid': error.entry_date }" class="form-control form-control-sm selectBorder"
                  :placeholder="date_mask.placeholder" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Interview Date']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Interview Date"]
                }}</label>
                <input v-maska:[date_mask.date_option] v-model="searchData.frominterview_date"
                  :class="{ 'is-invalid': error.interview_date }" class="form-control form-control-sm selectBorder"
                  :placeholder="date_mask.placeholder" />
                <span class="field-seperator">～</span>
                <input v-maska:[date_mask.date_option] v-model="searchData.tointerview_date"
                  :class="{ 'is-invalid': error.interview_date }" class="form-control form-control-sm selectBorder"
                  :placeholder="date_mask.placeholder" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Eyesight']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Eyesight"]
                }}</label>
                <select class="form-select form-select-sm selectBorder" v-model="searchData.eyesight">
                  <option selected value="">Select</option>
                  <option v-for="value in [1, 0.8, 0.5, 0.3]" :key="value" :value="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Age']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Age"]
                }}</label>
                <input type="number" class="form-control form-control-sm" v-model="searchData.fromAge" min="0"
                  @keypress="handleAgeInput($event)" :class="{ 'is-invalid': error.age }" />
                <span class="field-seperator">～</span>
                <input type="number" class="form-control form-control-sm" v-model="searchData.toAge" min="0"
                  @keypress="handleAgeInput($event)" :class="{ 'is-invalid': error.age }" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Height']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Height"]
                }}</label>
                <input type="number" class="form-control form-control-sm" v-model="searchData.fromHeight" min="0"
                  @keypress="handleInput($event)" :class="{ 'is-invalid': error.height }" />
                <span class="field-seperator">～</span>
                <input type="number" class="form-control form-control-sm" v-model="searchData.toHeight" min="0"
                  @keypress="handleInput($event)" :class="{ 'is-invalid': error.height }" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Weight']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Weight"]
                }}</label>
                <input type="number" class="form-control form-control-sm" v-model="searchData.fromWeight" min="0"
                  @keypress="handleInput($event)" :class="{ 'is-invalid': error.weight }" />
                <span class="field-seperator">～</span>
                <input type="number" class="form-control form-control-sm" v-model="searchData.toWeight" min="0"
                  @keypress="handleInput($event)" :class="{ 'is-invalid': error.weight }" />
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Gender']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Gender"]
                }}</label>
                <div v-for="(value, key) in radio.gender" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.gender" :value="key" />
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Marital Status']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Marital Status"]
                }}</label>
                <div v-for="(value, key) in radio.marital_status" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.marital_status" :value="key" />
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Handedness']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white handedness">{{
                  settingFilterObject["Handedness"]
                }}</label>
                <div v-for="(value, key) in radio.handedness" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.handedness" :value="key" />
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Medical Checkup']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Medical Checkup"]
                }}</label>
                <div v-for="(value, key) in radio.yes_no" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.medical_check" :value="key" />
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Smoking']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Smoking"]
                }}</label>
                <div v-for="(value, key) in radio.yes_no" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.smoking" :value="key" />
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Drinking']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Drinking"]
                }}</label>
                <div v-for="(value, key) in radio.yes_no" :key="key" class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="searchData.drinking" :value="key" />
                  <label class="form-check-label text-white">{{ value }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 my-2" v-if="settingFilterObject['Year']">
            <div class="row">
              <div class="col field-container">
                <label class="text-white">{{
                  settingFilterObject["Year"]
                }}</label>
                <input type="number" class="form-control form-control-sm" v-model="searchData.fromYear"
                  @keypress="handleYear($event)" :class="{ 'is-invalid': error.year }" />
                <span class="field-seperator">～</span>
                <input type="number" class="form-control form-control-sm" v-model="searchData.toYear"
                  @keypress="handleYear($event)" :class="{ 'is-invalid': error.year }" />
              </div>
            </div>
          </div>
        </div>
        <div class="row setting_filter_bg button-group py-2">
          <div class="col-md-4 mb-md-0 col-sm-5 mb-4 disable-check">
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input form-check-input-switch" v-model="isCheckedDelete"
                @change="handleCheckboxChange" />
              <div class="text-start">
                <label class="form-check-label">Deleted Data Show</label>
              </div>
            </div>
          </div>
          <div class="col-md-5 w-auto ms-auto">
            <input type="button" value="Search" class="btn btn-success me-2" v-on:click="Search" />
            <input type="button" value="Cancel" class="btn btn-secondary me-2" v-on:click.prevent="cancel()" />
          </div>
        </div>
        <div class="container dt-container mt-3">
          <div class="custom-show-entries">
            <select @change="updateResultsPerPage($event.target.value)" class="custom-select">
              <option v-for="value in drop_down.list_show" :key="value" :value="value">
                {{ value }}
              </option>
            </select>
            <span class="badge total-applicant">Total Applicants : {{ length }} &nbsp;</span>
          </div>
          <table id="dataTable" class="table table-responsive">
            <thead>
              <tr>
                <th class="check" data-orderable="false">
                  <input type="checkbox" class="form-check-input" v-on:click="checkAllApplicant()"
                    v-model="isCheckAll" />
                </th>
                <th v-for="header in tableHeaders.data" :key="header" :class="headerClass(header)">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in applicants" :key="index" class="table-data">
                <td :class="rowClass(row)">
                  <input type="checkbox" class="form-check-input" v-bind:value="row" v-model="selectedAllValues"
                    :checked="selectedApplicant(row.applicant_uid)" />
                </td>
                <td data-toggle="tooltip" v-bind:title="row[header]" v-for="header in tableHeaders.headers"
                  :key="header" :class="rowClass(row)" class="text-load">
                  <span v-if="header === 'name_eng'">
                    <router-link :to="{
                      name: 'applicantPreview',
                      params: { uid: row.applicant_uid },
                    }" v-if="permission && permission.data.preview === 1"
                      class="text-decoration-none text-black cursor-on">{{ row[header.toLowerCase()] }}</router-link>
                    <span v-else>{{ row[header.toLowerCase()] }}</span>
                  </span>
                  <span v-else>{{ row[header.toLowerCase()] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination controls -->
          <div class="pagination-container" v-if="totalPages > 1">
            <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1" class="pagination-button prev_btn">
              <span>&#x3c;</span>
            </button>
            <span v-if="paginationRange[0] > 1">
              <button @click="goToPage(1)" class="pagination-button">1</button>
              <span class="ellipsis">...</span>
            </span>
            <span v-for="pageNumber in paginationRange" :key="pageNumber">
              <button @click="goToPage(pageNumber)" :class="{ active: currentPage === pageNumber }"
                class="pagination-button">
                {{ pageNumber }}
              </button>
            </span>
            <span v-if="paginationRange[paginationRange.length - 1] < totalPages">
              <span class="ellipsis">...</span>
              <button @click="goToPage(totalPages)" class="pagination-button">
                {{ totalPages }}
              </button>
            </span>
            <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages"
              class="pagination-button next_btn">
              <span>&#x3e;</span>
            </button>
          </div>
          <div class="button-group my-3 d-flex justify-content-center footer-btn">
            <input type="button" v-if="permission && permission.data.download_list === 1" value="Download List"
              class="btn btn-success me-2" v-on:click="download" />
            <input type="button" v-if="permission && permission.data.set_interview === 1" value="Set Interview"
              class="btn btn-set-interview me-2" v-on:click="set_interview_click" />
            <input type="button" v-if="permission && permission.data.multi_delete === 1" value="Multi-Delete"
              class="btn btn-danger me-2" v-on:click="delete_data()" />
            <input type="button" v-if="permission && permission.data.download_cv === 1" value="Download CV"
              class="btn btn-success me-2" v-on:click="download_multiple()" />
          </div>
          <loading-modal :loading="loading_model.process_loading"
            :loading_text="loading_model.loading_text"></loading-modal>
        </div>
      </div>
      <!-- EndtOf検索 -->
      <!-- StartOfModalBox -->
      <div class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true" id="myModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Set Interview</h5>
              <button type="button" class="btn-close" v-on:click="clearInputsAndHideModal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row justify-content-center">
                <div class="row mb-2">
                  <label class="text-start col-md-6">Type of Occupations<span class="text-danger">*</span></label>
                  <div class="col-6">
                    <div class="input-container">
                      <input type="text" v-model="searchText" :class="{ 'is-invalid': error.jobTypeError }"
                        @input="filterItems" class="form-control" id="autocomplete" data-provide="typeahead" />
                      <ul v-if="filteredItems.length > 0 && searchText.length > 0" class="autocomplete-dropdown">
                        <li v-for="(item, index) in filteredItems" :key="item.id" class="list-group-item"
                          @click="selectItem(item)" @mouseover="hoverItem(index)" @mouseleave="unhoverItem(index)">
                          <span :style="{
                            cursor:
                              activeItem === index ? 'pointer' : 'default',
                          }">{{ item.name }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <label class="text-start col-md-6">Supervising Organization<span class="text-danger">*</span></label>
                  <div class="col-md-6">
                    <input type="text" v-model="setInterviewData.supervision_organization"
                      :class="{ 'is-invalid': error.sup_orgError }" :maxlength="set_interview_max_length.sup_org"
                      class="form-control" required />
                  </div>
                </div>
                <div class="row mb-2">
                  <label class="text-start col-md-6">Implementing Organization<span class="text-danger">*</span></label>
                  <div class="col-md-6">
                    <input v-model="setInterviewData.implementing_organization"
                      :class="{ 'is-invalid': error.impl_orgError }" type="text" class="form-control"
                      :maxlength="set_interview_max_length.imp_org" />
                  </div>
                </div>
                <div class="row mb-2">
                  <label class="text-start col-md-6">Interview Date<span class="text-danger">*</span></label>
                  <div class="col-md-6">
                    <input v-maska:[date_mask.date_option] v-model="setInterviewData.interview_date"
                      :class="{ 'is-invalid': error.interview_dateError }"
                      class="form-control form-control-sm selectBorder" :placeholder="date_mask.placeholder" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" v-on:click="set_interview_save">
                Save
              </button>
              <button type="button" class="btn btn-secondary" v-on:click="clearInputsAndHideModal" data-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- EndtOfModalBox -->
    </div>
  </div>
</template>

<style lang="css" scoped src="@/assets/css/applicantList.css"></style>

<script>
import MenuLayout from "@/components/MenuLayout.vue";
import Configuration from "@/Service/configuration.js";
import DataService from "@/Service/data-service.js";
import ConstantVar from "@/Service/constant-var.js";
import Enum from "@/Service/enum.js";
import Swal from "sweetalert2";
import LoadingModal from "@/components/LoadingModal.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { vMaska } from "maska";
import { checkDate } from "@/Util/checkDate.js";
import { swal_option } from "@/Util/swal-option.js";
import { mapState } from "vuex";
import { whiteSpaceCase } from "@/Util/whiteSpaceCase.js";
import { dropdownSelect } from "@/Util/dropdownSelect.js";
import { msg_code } from "@/Util/msg_code.js";
import "bootstrap";
import { Modal } from "bootstrap"; //Modal
// for datatable
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.css";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
var dataService = new DataService();
var config = new Configuration();
var enums = new Enum();
var con_var = new ConstantVar();
export default {
  components: {
    MenuLayout,
    LoadingSpinner,
    "loading-modal": LoadingModal,
  },
  directives: { maska: vMaska },
  data() {
    return {
      loading: null,
      loading_model: {},
      max_length: {},
      set_interview_max_length: {},
      date_mask: {},
      drop_down: {
        blood_type: [],
        interview_status: [],
        religion: [],
        passport_type: [],
        edu_grade: [],
        list_show: [],
        birth_state: [],
        birth_city: [],
        travel_country: [],
        other_possible_languages: [],
        recruited_from: []
      },
      radio: {
        gender: [],
        yes_no: [],
        handedness: [],
        marital_status: [],
      },
      applicants: [],
      tableHeaders: {
        headers: [],
        data: [],
      },
      modal: null,
      selectedAllValues: [],
      isCheckAll: false,
      ids: [],
      jobTypeList: [],
      downloadUrl: "",
      responseData: {},
      setInterviewData: {},
      setInterview: {
        data: {},
        ids: [],
      },
      settingFilterObject: {},
      length: 0,
      responseDataCount: 0,
      currentDate: new Date().toISOString().split("T")[0], // Get the current date in ISO format (yyyy-mm-dd)
      error: {
        jobTypeError: false,
        sup_orgError: false,
        impl_orgError: false,
        interview_dateError: false,
        age: false,
        height: false,
        weight: false,
        year: false,
        apply_date: false,
        entry_date: false,
        interview_date: false,
        dob: false,
      },
      isCheckedDelete: false,
      deleteApplicants: [],
      searchApplicants: [],
      items: [],
      filteredItems: [],
      searchText: "",
      searchData: {
        blood_type: "",
        job_category_uid: "",
        interview_status: "",
        marital_status: "",
        religion: "",
        passport_type: "",
        edu_history: "",
        birth_state: "",
        birth_city: "",
        foreign_travel_history: "",
        other_possible_languages: "",
        has_refer: '',
        recruited_from: '',
        eyesight_botheye: "",
        glass_botheye: "",
        eyesight: ""
      },
      totalPages: 0,
      currentPage: 1,
      resultsPerPage: 20,
      activeItem: -1,
      downloadData: [],
    };
  },
  async mounted() {
    this.loading = con_var.LOADING_INTI;
    this.loading_model = con_var.LOADING_MODEL;
    this.max_length = con_var.APPLICANT_MAX_LENGTH;
    this.set_interview_max_length = con_var.SET_INTERVIEW_MAX_LENGTH;
    this.date_mask = con_var.DATE_MASK;
    //for settingFilter
    this.drop_down.blood_type = enums.BLOOD_TYPE;
    this.drop_down.interview_status = enums.INTERVIEW_STATUS;
    this.drop_down.religion = enums.RELIGION;
    this.drop_down.passport_type = enums.PASSPORT_TYPE;
    this.drop_down.edu_grade = enums.EDU_GRADE;
    this.drop_down.list_show = con_var.LIST_APPLICANT_SHOW;
    this.drop_down.birth_state = con_var.STATE;
    this.drop_down.travel_country = con_var.TRAVEL_COUNTRY;
    this.drop_down.other_possible_languages = con_var.LANGUAGE;
    this.drop_down.recruited_from = con_var.REFERRAL_SCHOOL || con_var.REFERAL_SCHOOL;
    this.radio.yes_no = enums.YES_NO;
    this.radio.gender = enums.GENDER;
    this.radio.marital_status = enums.MARITAL_STATUS;
    this.radio.handedness = enums.HANDEDNESS;
    var serverResponse_job_category = await dataService.retrieveWithGet(
      config.SERVICE_NAME_JOB_CATEGORY,
    );
    var serverResponse_job_type = await dataService.retrieveWithGet(
      config.SERVICE_NAME_JOB_TYPE,
    );
    this.jobTypeList = serverResponse_job_type.data;
    this.jobCategoryList = serverResponse_job_category.data;
    this.fetchData();
    this.modal = null;
    this.setCurrentYear();
    this.items = this.jobTypeList;
    this.loading = false;
  },
  computed: {
    ...mapState(["userEmail", "userID", "permission"]),
    rowClass() {
      return function (item) {
        if (item) {
          return {
            "class-condition1": item.del_flg === 1,
            "class-condition2":
              item.del_flg === 0 && item.interview_status === "P",
            "class-condition3":
              item.del_flg === 0 && item.interview_status === "N",
            "class-condition4":
              item.del_flg === 1 && item.interview_status === "P",
            "class-condition5":
              item.del_flg === 1 && item.interview_status === "N",
          };
        }
        // If item is undefined or null, return an empty object (no classes)
        return {};
      };
    },
    selectedDataArray() {
      const sortedData = Object.values(this.ids).sort((a, b) => a - b);
      if (!Array.isArray(sortedData)) {
        return [sortedData];
      }
      return sortedData;
    },
    paginationRange() {
      const maxPaginationNumbers = 4;
      let start = Math.max(
        1,
        this.currentPage - Math.floor(maxPaginationNumbers / 2),
      );
      let end = Math.min(start + maxPaginationNumbers - 1, this.totalPages);

      // Adjust start and end if there are not enough pagination numbers on the right
      if (end - start + 1 < maxPaginationNumbers) {
        start = Math.max(1, end - maxPaginationNumbers + 1);
      }

      const rangeArray = [];
      for (let i = start; i <= end; i++) {
        rangeArray.push(i);
      }
      return rangeArray;
    },
  },
  methods: {
    stateChange() {
      this.searchData.birth_city = "";
      const state = this.drop_down.birth_state.find(
        (s) => s.en === this.searchData.birth_state,
      );
      this.drop_down.birth_city = state ? con_var.CITY[state.id] : [];
    },
    selectedApplicant(uid) {
      return this.ids.includes(uid);
    },
    setCurrentYear() {
      const currentYear = new Date().getFullYear();
      this.searchData.fromYear = currentYear;
      this.searchData.toYear = currentYear;
    },
    filterItems() {
      this.filteredItems = this.items.filter((item) =>
        item.name.toLowerCase().startsWith(this.searchText.toLowerCase()),
      );
    },
    hoverItem(index) {
      this.activeItem = index;
    },
    unhoverItem() {
      this.activeItem = -1;
    },
    selectItem(item) {
      this.searchText = item.name;
      const foundObject = this.jobTypeList.find(
        (items) => items.name === item.name,
      );
      this.setInterviewData.job_type_uid = foundObject.uid;
      this.filteredItems = [];
    },
    headerClass(header) {
      if (header === "更新者" || header === "更新日") {
        return "custom-width-0";
      } else if (header === "番号" || header === "性別" || header === "年齢") {
        return "custom-width-1";
      } else if (
        header === "登録日" ||
        header === "名前" ||
        header === "生年月日"
      ) {
        return "custom-width-2";
      } else if (
        header === "証明書/学位を持っている" ||
        header === "日本の友人/親戚" ||
        header === "パスポート有効期限" ||
        header === "パスポートの種類" ||
        header === "証明書/学位名＋日本語資格" ||
        header === "その他の可能な言語"
      ) {
        return "custom-width-3";
      } else {
        return "custom-width-4";
      }
    },
    changeLongForm(item) {
      item["religion"] = enums.RELIGION[item["religion"]];
      item["medical_check"] = this.radio.yes_no[item["medical_check"]];
      item["has_edu_qualification"] =
        this.radio.yes_no[item["has_edu_qualification"]];
      item["has_jp_friend"] = this.radio.yes_no[item["has_jp_friend"]];
      if (item["various_qualifications"] == null && item["jp_qualifications"]) {
        item["various_qualifications"] = item["jp_qualifications"];
      }
    },
    async fetchData() {
      var serverResponse = await dataService.retrieveWithGet(
        config.SERVICE_NAME_SETTING + "/" + this.userID,
      );
      this.tableHeaders.headers = serverResponse.data.selectedDBColumns;
      this.tableHeaders.data = serverResponse.data.selectedColumnsJapanese;
      this.initDataTableAfterFetch();
      this.settingFilterList = serverResponse.data.checkFilterData;
      this.settingFilterList.forEach((value) => {
        this.settingFilterObject[value] = value;
      });
    },
    initDataTableAfterFetch() {
      this.$nextTick(() => {
        const table = $(this.$el)
          .find("#dataTable")
          .DataTable({
            scrollX: true,
            scrollY: "450px",
            searching: false,
            paging: false,
            lengthChange: false,
            order: [],
            language: {
              info: "Page " + this.currentPage + " of " + this.totalPages,
              paginate: {
                next: "&#x3e;", // or '>'
                previous: "&#x3c;", // or '<'
              },
              sLengthMenu: "_MENU_ ",
            },
          });
        // Check if the table has data
        const dataExists = table.data().any();
        if (dataExists) {
          table.order([[1, "asc"]]).draw();
        }
      });
    },
    reinitializeDataTable() {
      var table = $("#dataTable").DataTable();
      table.destroy();
      this.initDataTableAfterFetch();
    },
    async checkAllApplicant() {
      this.isCheckAll = !this.isCheckAll;
      if (this.selectedAllValues.length != null) {
        const concatenatedArray = this.applicants.concat(
          this.selectedAllValues,
        );
        this.selectedAllValues = concatenatedArray;
      } else {
        this.selectedAllValues = this.applicants;
      }
      if (this.isCheckAll) {
        if (this.ids) {
          this.selectedAllValues.forEach((id) => {
            if (!this.ids.includes(id)) {
              this.ids.push(id);
            }
          });
        } else {
          this.ids = Array.from(this.selectedAllValues);
        }
      } else {
        this.applicants.forEach((applicant) => {
          const indexToDelete = this.ids.findIndex(
            (item) => item.applicant_uid === applicant.applicant_uid,
          );
          if (indexToDelete !== -1) {
            this.ids.splice(indexToDelete, 1);
          }
        });
      }
      this.selectedAllValues = this.ids;
    },
    async download() {
      if (this.applicants.length === 0) {
        Swal.fire(swal_option("info", msg_code("if001")));
      } else {
        this.loading_model = {
          process_loading: true,
          loading_text: "Downloading",
        };
        const params = {
          uid: this.userID,
          search_data: this.searchData,
        };
        const serverResponse = await dataService.downloadFileWithGet(
          config.SERVICE_NAME_APPLICANT_DOWNLOAD,
          params,
        );
        const url = window.URL.createObjectURL(new Blob([serverResponse.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `ApplicantList.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.loading_model = con_var.LOADING_MODEL;
      }
      // Uncheck all checkboxes
      $(this.$el)
        .find('#dataTable tbody tr td:first-child input[type="checkbox"]')
        .prop("checked", false);
      // Uncheck the "Select All" checkbox after download
      $(".selectAllCheckbox").prop("checked", false);
      this.selectedData = [];
      this.idArray = [];
      this.checkApplicantflg = false;
      this.selectedAllValues = [];
      this.isCheckAll = false;
    },
    async download_multiple() {
      let fileName;
      var uniqueApplicantIds = new Set();
      this.selectedAllValues.forEach((item) => {
        if (item && item.applicant_uid) {
          uniqueApplicantIds.add(item.applicant_uid);
        }
      });
      this.ids = Array.from(uniqueApplicantIds);
      var requestData = { selectedData: this.selectedDataArray };
      if (requestData.selectedData.length === 0) {
        return Swal.fire(swal_option("warn", msg_code("wf001")));
      }
      if (requestData.selectedData.length > con_var.MAX_DOWNLOAD) {
        return Swal.fire(swal_option("warn", msg_code("wf002")));
      }
      this.loading_model = {
        process_loading: true,
        loading_text: "Downloading CV",
      };
      try {
        var response = await dataService.downloadFileWithGet(
          config.SERVICE_NAME_APPLICANT_EXPORT_MULTIPLE,
          requestData,
          { responseType: "blob" },
        );
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition.includes("filename=")) {
          const matches = contentDisposition.match(/filename=([^;]+)/);
          if (matches && matches[1]) {
            fileName = matches[1].trim();
          }
        } else {
          console.error(
            "Unable to extract fileName from Content-Disposition header",
          );
        }
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        this.loading_model = con_var.LOADING_MODEL;
        this.selectedAllValues = [];
        this.ids = [];
        this.isCheckAll = false;
      } catch (error) {
        console.error("Error during download:", error);
      }
    },
    dataCheck() {
      var flg = true;
      if (this.searchData.fromapply_date || this.searchData.toapply_date) {
        if (!(this.searchData.fromapply_date && this.searchData.toapply_date)) {
          this.error.apply_date = true;
        } else {
          if (
            checkDate(this.searchData.fromapply_date) &&
            checkDate(this.searchData.toapply_date)
          ) {
            this.error.apply_date = false; // date exist and correct case
          } else {
            this.error.apply_date = true;
          }
        }
      } else {
        this.error.apply_date = false;
      }
      if (this.searchData.fromentry_date || this.searchData.toentry_date) {
        if (!(this.searchData.fromentry_date && this.searchData.toentry_date)) {
          this.error.entry_date = true;
        } else {
          if (
            checkDate(this.searchData.fromentry_date) &&
            checkDate(this.searchData.toentry_date)
          ) {
            this.error.entry_date = false; // date exist and correct case
          } else {
            this.error.entry_date = true;
          }
        }
      } else {
        this.error.entry_date = false;
      }
      if (
        this.searchData.frominterview_date ||
        this.searchData.tointerview_date
      ) {
        if (
          !(
            this.searchData.frominterview_date &&
            this.searchData.tointerview_date
          )
        ) {
          this.error.interview_date = true;
        } else {
          if (
            checkDate(this.searchData.frominterview_date) &&
            checkDate(this.searchData.tointerview_date)
          ) {
            this.error.interview_date = false; // date exist and correct case
          } else {
            this.error.interview_date = true;
          }
        }
      } else {
        this.error.interview_date = false;
      }
      if (this.searchData.fromAge || this.searchData.toAge) {
        if (!(this.searchData.fromAge && this.searchData.toAge)) {
          this.error.age = true;
        } else {
          this.error.age = false;
        }
      } else {
        this.error.age = false;
      }
      if (this.searchData.fromHeight || this.searchData.toHeight) {
        if (!(this.searchData.fromHeight && this.searchData.toHeight)) {
          this.error.height = true;
        } else {
          this.error.height = false;
        }
      } else {
        this.error.height = false;
      }
      if (this.searchData.fromWeight || this.searchData.toWeight) {
        if (!(this.searchData.fromWeight && this.searchData.toWeight)) {
          this.error.weight = true;
        } else {
          this.error.weight = false;
        }
      } else {
        this.error.weight = false;
      }
      if (!(this.searchData.fromYear && this.searchData.toYear)) {
        this.error.year = true;
      } else {
        this.error.year = false;
      }
      if (this.searchData.dob) {
        if (checkDate(this.searchData.dob)) {
          this.error.dob = false;
        } else {
          this.error.dob = true;
        }
      } else {
        this.error.dob = false;
      }

      if (
        this.error.age ||
        this.error.height ||
        this.error.weight ||
        this.error.year ||
        this.error.apply_date ||
        this.error.entry_date ||
        this.error.interview_date ||
        this.error.dob
      ) {
        flg = false;
      }
      return flg;
    },
    Search() {
      this.isCheckAll = false;
      this.currentPage = 1;
      this.selectedAllValues = [];
      this.search_data();
    },
    async search_data() {
      this.loading_model = {
        process_loading: true,
        loading_text: "Processing",
      };
      if (this.dataCheck()) {
        this.searchData = whiteSpaceCase(this.searchData);
        this.searchData.page = this.currentPage;
        this.searchData.resultsPerPage = this.resultsPerPage;
        //Deleted data show
        if (this.isCheckedDelete) {
          this.searchData.status = true;
        } else {
          delete this.searchData.status;
        }
        this.searchData["userID"] = this.userID;
        var serverResponse = await dataService.callWithPost(
          config.SERVICE_NAME_APPLICANT_SEARCH,
          this.searchData,
        );
        this.length = serverResponse.data.total;
        this.responseData = serverResponse.data.data;
        if (serverResponse.success) {
          Object.keys(this.responseData).forEach((key) => {
            const item = this.responseData[key];
            this.changeLongForm(item);
          });
          this.totalPages = serverResponse.data.last_page;
          this.applicants = this.responseData;

          if (this.length == 0) {
            Swal.fire(swal_option("info", msg_code("if002")));
          }
          this.reinitializeDataTable();
        } else {
          console.error(serverResponse.message);
        }
        this.length = serverResponse.data.total;
        this.searchData = dropdownSelect(this.searchData, "listView");
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    async goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        await this.search_data();
        const selectedApplicantUids = this.applicants.map(
          (item) => item.applicant_uid,
        );
        const Included = this.selectedAllValues.filter((applicant) => {
          return selectedApplicantUids.some(
            (uid) => uid === applicant.applicant_uid,
          );
        });
        if (Included.length != 0) {
          if (Included.length < this.resultsPerPage) {
            this.isCheckAll = true;
          } else {
            this.isCheckAll = true;
          }
        } else if (Included.length == 0) {
          this.isCheckAll = false;
        }
      }
    },
    async onPageChange(newPage) {
      this.currentPage = newPage;
      await this.search_data();
    },
    async updateResultsPerPage(value) {
      this.resultsPerPage = value;
      this.searchData.resultsPerPage = this.resultsPerPage;
    },
    clearError() {
      this.error.age = false;
      this.error.height = false;
      this.error.weight = false;
      this.error.year = false;
      this.error.apply_date = false;
      this.error.entry_date = false;
      this.error.interview_date = false;
      this.error.dob = false;
    },
    async cancel() {
      this.applicants = [];
      const currentYear = new Date().getFullYear();
      this.searchData = {
        blood_type: "",
        job_category_uid: "",
        interview_status: "",
        marital_status: "",
        religion: "",
        passport_type: "",
        edu_history: "",
        gender: null,
        handedness: null,
        homephone: null,
        cellphone: null,
        edu_qualifications: null,
        eyesight: null,
        school_grade: null,
        implementing_organization: null,
        jp_qualifications: null,
        name_eng: null,
        nrc: null,
        supervision_organization: null,
        apply_date: null,
        entry_date: null,
        interview_date: null,
        has_edu_qualification: null,
        fromAge: null,
        toAge: null,
        fromHeight: null,
        toHeight: null,
        fromWeight: null,
        toWeight: null,
        fromYear: currentYear,
        toYear: currentYear,
        birth_state: "",
        birth_city: "",
        foreign_travel_history: "",
        other_possible_languages: "",
        has_refer: null,
        recruited_from: ""
      };
      this.date = "";
      this.length = 0;
      this.isCheckedDelete = false;
      this.selectedAllValues = [];
      this.isCheckAll = false;
      this.currentPage = 1;
      this.totalPages = 0;
      this.clearError();
      var table = $("#dataTable").DataTable();
      table.clear();
      table.draw();
      table.destroy();
      this.initDataTableAfterFetch();
    },
    set_interview_click() {
      if (this.selectedAllValues.length === 0) {
        return Swal.fire(swal_option("warn", msg_code("wf003")));
      }
      this.modal = new Modal(this.$refs.exampleModal, { backdrop: "static" });
      this.modal.show();
    },
    validateForm() {
      //入力を検証する
      this.error.jobTypeError = false;
      this.error.sup_orgError = false;
      this.error.impl_orgError = false;
      this.error.interview_dateError = false;
      if (
        !this.setInterviewData.job_type_uid ||
        !this.setInterviewData.supervision_organization ||
        !this.setInterviewData.implementing_organization ||
        !this.setInterviewData.interview_dateError
      ) {
        if (!this.setInterviewData.job_type_uid) {
          this.error.jobTypeError = true;
        } else {
          this.error.jobTypeError = false;
        }
        if (!this.setInterviewData.supervision_organization) {
          this.error.sup_orgError = true;
        } else {
          this.error.sup_orgError = false;
        }
        if (!this.setInterviewData.implementing_organization) {
          this.error.impl_orgError = true;
        } else {
          this.error.impl_orgError = false;
        }
        if (!this.setInterviewData.interview_date) {
          this.error.interview_dateError = true;
        } else {
          if (checkDate(this.setInterviewData.interview_date)) {
            this.error.interview_dateError = false;
          } else {
            this.error.interview_dateError = true;
          }
        }
      } else {
        this.error.jobTypeError = false;
        this.error.sup_orgError = false;
        this.error.impl_orgError = false;
        this.error.interview_dateError = false;
      }
      return (
        this.error.jobTypeError ||
        this.error.sup_orgError ||
        this.error.impl_orgError ||
        this.error.interview_dateError
      );
    },
    async set_interview_save() {
      this.searchApplicants = [];
      if (this.validateForm()) {
        return;
      }
      this.ids = [];
      this.selectedAllValues.forEach((item) => {
        this.ids.push(item.applicant_uid);
      });
      this.loading_model = {
        process_loading: true,
        loading_text: "Processing",
      };
      if (this.setInterviewData != null) {
        this.setInterview.data = this.setInterviewData;
        this.setInterview.data.created_by = this.userID;
        this.setInterview.ids = this.ids;
        var serverResponse_set_interview = await dataService.callWithPost(
          config.SERVICE_NAME_SET_INTERVIEW,
          this.setInterview,
        );
        if (serverResponse_set_interview.success == true) {
          var total = this.ids.length;
          this.loading_model = con_var.LOADING_MODEL;
          var messageWithAdditionalText =
            "Total Person : " + total + " has been set interview successfully.";
          Swal.fire(swal_option("success", messageWithAdditionalText));
          this.isCheckAll = false;
          this.selectedAllValues = [];
          this.ids = [];
          this.modal.hide();
          var serverResponse = await dataService.callWithPost(
            config.SERVICE_NAME_APPLICANT_SEARCH,
            this.searchData,
          );
          this.responseData = serverResponse.data.data;
          Object.keys(this.responseData).forEach((key) => {
            const item = this.responseData[key];
            if (item["edu_history"] != null) {
              const itemsArray = item["edu_history"].split(",");
              itemsArray.forEach((substring) => {
                const lastLetter = substring.trim().slice(-1);
                item["edu_history"] = lastLetter;
              });
            }
            this.changeLongForm(item);
            this.searchApplicants.push(item);
          });
          this.applicants = this.searchApplicants;
          this.reinitializeDataTable();
        } else {
          Swal.fire(swal_option("error", serverResponse_set_interview.message));
        }
        this.cancelSetInterview();
        this.isCheckAll = false;
      }
    },
    clearInputsAndHideModal() {
      this.cancelSetInterview();
      this.error.jobTypeError = false;
      this.error.sup_orgError = false;
      this.error.impl_orgError = false;
      this.error.interview_dateError = false;
      this.modal.hide();
    },
    async cancelSetInterview() {
      this.searchText = "";
      this.filteredItems = 0;
      this.setInterviewData = {
        job_type_uid: null,
        supervision_organization: null,
        implementing_organization: null,
        interview_date: null,
        created_by: null,
      };
    },
    async delete_data() {
      if (this.selectedAllValues.length === 0) {
        return Swal.fire(swal_option("warn", msg_code("wf004")));
      }
      this.ids = [];
      this.selectedAllValues.forEach((item) => {
        this.ids.push(item.applicant_uid);
      });
      var serverResponse = null;
      Swal.fire(swal_option("confirm", msg_code("cf015"))).then(
        async (result) => {
          if (result.isConfirmed) {
            this.loading_model = {
              process_loading: true,
              loading_text: "Processing",
            };
            serverResponse = await dataService.callWithPost(
              config.SERVICE_NAME_APPLICANT_MULTIDELETE,
              this.ids,
            );
            var response = await dataService.callWithPost(
              config.SERVICE_NAME_APPLICANT_SEARCH,
              this.searchData,
            );
            if (serverResponse.success == true) {
              Swal.fire(swal_option("success", serverResponse.message));
              this.isCheckAll = false;
              this.selectedAllValues = [];
              this.ids = [];
              this.applicants = response.data.data;
              this.reinitializeDataTable();
            }
            this.loading_model = con_var.LOADING_MODEL;
          }
        },
      );
    },
    handleInput(event) {
      const maxLength = this.max_length.height_weight;
      if (event.target.value.length >= maxLength) {
        event.preventDefault();
      }
    },
    handleAgeInput(event) {
      const maxLength = this.max_length.age;
      if (event.target.value.length >= maxLength) {
        event.preventDefault();
      }
    },
    handleYear(event) {
      const maxLength = this.max_length.year;
      if (event.target.value.length >= maxLength) {
        event.preventDefault();
      }
    },
    handleEyeInput(event) {
      const maxLength = this.max_length.eyes;
      if (event.target.value.length >= maxLength) {
        event.preventDefault();
      }
    },
  },
};
</script>
